import BlueByteLogo from '@assets/blue_byte_logo.svg';
import { TEXT_COLORS as TC } from '@constants/colors.ts';
import { DESKTOP_SIZES, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const FooterLogoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: auto;
`;

export const BlueByteLogoWrapper = styled(BlueByteLogo)`
    width: 110px;
`;

export const PoweredBy = styled.div`
    color: ${TC.poweredBy};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_SM_MED].fontWeight}
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight}
`;

export const Version = styled.div`
    width: 504px;
    margin-top: 8px;
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontWeight}
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight}
    color: var(--colors-text-on-disabled, #70768D);
    text-align: center;
`;
